import React, { useState, useCallback } from 'react'
import { connect } from 'react-redux'
import { useAppDispatch } from '../reducers'
import { createSelector } from 'reselect'

import { removeError } from '../actions/errors'
import {
  dismissProgressItem,
  showLink,
  openPopupReminder,
  surpressPopupReminder
} from '../actions/ui'

import { createTenant } from '../actions/tenant'

import {
  getUser,
  getErrors,
  getProgressSnackVisibility,
  getNotification,
  getLinkNotification,
  getLinkToProject,
  getLoginConfig,
  getSupportConfig,
  getTutorial,
  getApplicationsNotifications,
  getAppStatus,
  getOpenAppStatus,
  getPopupReminderIsOpen,
  getSurpressPopupReminder,
  getProgressItems,
  getLoadingTenants,
  getTenants,
  getUserIsAdmin,
  getUserIsBackOffice,
  getLoadingApplications,
  getApplications,
  getProjectDetails,
  getGroups,
  getTenantFeatures,
  getProject
} from '../state'

import App from '../components/App'

const mapStateToProps = createSelector(
  [
    getUser,
    getProgressSnackVisibility,
    getNotification,
    getLinkNotification,
    getLinkToProject,
    getLoginConfig,
    getSupportConfig,
    getTutorial,
    getErrors,
    getApplicationsNotifications,
    getAppStatus,
    getOpenAppStatus,
    getPopupReminderIsOpen,
    getSurpressPopupReminder,
    getProgressItems,
    getLoadingTenants,
    getTenants,
    getUserIsAdmin,
    getUserIsBackOffice,
    getLoadingApplications,
    getApplications,
    getProjectDetails,
    getGroups,
    getTenantFeatures,
    getProject
  ],
  (
    user,
    progressSnackVisible,
    notification,
    linkNotification,
    linkToProject,
    loginConfig,
    support,
    tutorial,
    errors,
    appNotifications,
    appStatus,
    appStatusIsOpen,
    popupReminderIsOpen,
    surpressPopupReminderState,
    progressItems,
    loadingTenants,
    tenants,
    isAdmin,
    isBackOffice,
    loadingApps,
    apps,
    project,
    groups,
    features,
    currentProject
  ) => ({
    user,
    progressSnackVisible,
    notification,
    linkNotification,
    linkToProject,
    loginConfig,
    support,
    tutorial,
    errors,
    appNotifications,
    appStatus,
    appStatusIsOpen,
    popupReminderIsOpen,
    surpressPopupReminder: surpressPopupReminderState,
    progressItems,
    loadingTenants,
    tenants,
    isAdmin,
    isBackOffice,
    loadingApps,
    apps,
    project,
    groups,
    features,
    currentProject
  })
)

// Wraps App to provide local UI state and handlers that were previously
// supplied via recompose withState/withHandlers.
const AppWithLocalState: React.FC<any> = props => {
  const dispatch = useAppDispatch()
  const [openCreateTenant, setOpenCreateTenant] = useState(false)

  const onCreateTenantCloseClick = useCallback(
    () => setOpenCreateTenant(false),
    []
  )
  const onOpenCreateTenant = useCallback(() => setOpenCreateTenant(true), [])
  const onCreateTenant = useCallback(
    data => {
      dispatch(createTenant(data))
      setOpenCreateTenant(false)
    },
    [dispatch]
  )
  const onDismissProgressListItem = useCallback(
    ({ id }) => dispatch(dismissProgressItem(id)),
    [dispatch]
  )
  const onCloseLinkNotification = useCallback(
    () => dispatch(showLink(null, null)),
    [dispatch]
  )
  const onCloseError = useCallback(id => dispatch(removeError(id)), [dispatch])
  const onClosePopupReminder = useCallback(
    () => dispatch(openPopupReminder(false)),
    [dispatch]
  )
  const onSurpressPopupReminder = useCallback(
    (surpress: boolean) => {
      localStorage.setItem(
        'supressActivatePopupReminder',
        surpress ? 'true' : 'false'
      )
      dispatch(surpressPopupReminder(surpress))
    },
    [dispatch]
  )

  return React.createElement(App, {
    ...props,
    openCreateTenant,
    onCreateTenantCloseClick,
    onOpenCreateTenant,
    onCreateTenant,
    onDismissProgressListItem,
    onCloseLinkNotification,
    onCloseError,
    onClosePopupReminder,
    onSurpressPopupReminder
  })
}

export default connect(mapStateToProps)(AppWithLocalState)
